import { extractCookie } from 'lib/web/cookieUtils'

export function setGeoCoordsCookie(latitude: number, longitude: number) {
  document.cookie = `geocoords=${latitude},${longitude}; expires=Fri, 29 Dec 2028 23:59:59 GMT; path=/; domain=${document.domain}`
}

export function getGeoCoords(): { latitude: number, longitude: number } | undefined {
  const cookieValue = extractCookie(document.cookie, 'geocoords') ?? ''
  const [latitude, longitude] = cookieValue.split(',').filter(Boolean)

  if (latitude && longitude) {
    return {
      latitude: parseInt(latitude),
      longitude: parseInt(longitude),
    }
  }
}
